
export interface SyncParams {
  RecordId: number,
  Type: SyncDownloadType,
  Id: string,
  ReferenceDataModifiedDateFrom: string,
  TimeDataFilters: SyncParamsFilter[]
}

export interface FlattendSyncParams {
  Type: SyncDownloadType,
  Id: string,
  ReferenceDataModifiedDateFrom: string,
  TimeDataStartDate: string
  TimeDataEndDate: string
  TimeDataModifiedDateFrom: string
}

export enum SyncDownloadType {
  AppUser = "app-user",
  Team = "team",
  Project = "project"
}

type SyncParamsFilter = {
  StartDate: string
  EndDate: string
  ModifiedDateFrom: string
}